const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(1),
  },
  row: {
    cursor: 'pointer',
  },
  rowSelected: {
    background: theme.palette.grey[100],
  },
});

export default styles;
